import { FlexBox, Text } from '@dixa/lib-shared-habla';

import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type AgentPresenceStatusChangedProps = {
  entry: UserAuditLogEntry<'AGENT_PRESENCE_STATUS_CHANGED'>;
};

export const AgentPresenceStatusChanged = ({
  entry,
}: AgentPresenceStatusChangedProps): JSX.Element => {
  const title =
    entry.presence_status !== entry.previous_presence_status
      ? `Presence status changed from ${entry.previous_presence_status.toLowerCase()} to ${entry.presence_status.toLowerCase()}`
      : 'Away status changed';

  const summary = (() => {
    if (
      entry.presence_status !== 'AWAY' ||
      entry.custom_away_status?.id === entry.previous_custom_away_status?.id
    ) {
      return null;
    }

    const from = entry.previous_custom_away_status ? (
      <Text.Paragraph variant="3" as="span">
        {entry.previous_custom_away_status.emoji}{' '}
        {entry.previous_custom_away_status.label}
      </Text.Paragraph>
    ) : null;

    const to = entry.custom_away_status ? (
      <Text.Paragraph variant="3" as="span">
        {entry.custom_away_status.emoji} {entry.custom_away_status.label}
      </Text.Paragraph>
    ) : null;

    return (
      <FlexBox padding="100 0" gap="100" alignItems="center">
        {from && to ? (
          <>
            From {from} to {to}
          </>
        ) : to ? (
          <>Set {to}</>
        ) : (
          <>Cleared {from}</>
        )}
      </FlexBox>
    );
  })();

  return (
    <UserActivityCard
      entry={entry}
      color={statusColors.info}
      icon="working"
      title={title}
      summary={summary}
    />
  );
};
